import _ from 'lodash';

export const getChangedFields = (selectedBuyBox, updatedParams) => {
  const areasComparer = (a, b) => a.formattedAddress === b.formattedAddress;
  const genericComparer = (a, b) => _.isEqual(a, b);
  const fields = Object.keys(selectedBuyBox);

  return fields.reduce((res, name) => {
    if (
      name === 'areas' &&
      !areasComparer(selectedBuyBox[name], updatedParams[name])
    ) {
      res[name] = updatedParams[name];
    }
    if (!genericComparer(selectedBuyBox[name], updatedParams[name])) {
      res[name] = updatedParams[name];
    }
    return res;
  }, {});
};

export const findAddedAndRemovedAreas = (obj1, obj2) => {
  const areas1 = obj1.areas || [];
  const areas2 = obj2.areas || [];

  const addedAreas = _.difference(areas2, areas1);
  const removedAreas = _.difference(areas1, areas2);

  return {
    addedAreas,
    removedAreas,
  };
};